import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHandshake,
  faCalendarCheck,
  faClipboardList,
  faCar,
  faPhone,
  faShieldAlt,
  faPhoneAlt,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import "./Hoe.css";

export default function Hoe() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-10%" });

  const steps = [
    {
      icon: faShieldAlt,
      title: "Verzekering contacteren",
      description:
        "Gaat het om een verzekeringsgeval? Informeer eerst je makelaar en geef onze carrosserie door als erkende hersteller.",
    },
    {
      icon: faCalendarCheck,
      title: "Afspraak maken",
      description:
        "Maak bij voorkeur een afspraak voor een prijsofferte en foto's via telefoon of e-mail. Wij helpen je graag verder.",
    },
    {
      icon: faClipboardList,
      title: "Schadeopname",
      description:
        "Je komt langs op het afgesproken tijdstip. Wij maken een schadedossier en plannen de herstelling in.",
    },
    {
      icon: faCar,
      title: "Wagen brengen",
      description:
        "Breng je wagen op de geplande hersteldatum — bij voorkeur in de voormiddag.",
    },
    {
      icon: faPhone,
      title: "Klaar voor ophaling",
      description:
        "Zodra de wagen klaar is, bellen wij je om de ophaling af te spreken.",
    },
    {
      icon: faHandshake,
      title: "Administratie",
      description:
        "Voor dossiers waarbij wij erkend hersteller zijn, regelen wij alle contacten en de afhandeling rechtstreeks met de verzekeraar.",
    },
  ];

  return (
    <section id="schade" className="damage-section" ref={ref}>
      <div className="damage-container">
        {/* Header */}
        <motion.div
          className="damage-header"
          initial={{ opacity: 0, y: 28 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 28 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <span className="section-badge">Procedure</span>
          <h2 className="damage-title">Schade, wat nu?</h2>
          <p className="damage-intro">
            Volg deze eenvoudige stappen voor een vlotte afhandeling van uw
            autoschade.
          </p>
        </motion.div>

        {/* Vertical Technical Timeline */}
        <div className="steps-timeline">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="step-item"
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
              transition={{
                duration: 0.8,
                delay: 0.3 + index * 0.1,
                ease: [0.16, 1, 0.3, 1],
              }}
            >
              <div className="step-number">
                {String(index + 1).padStart(2, "0")}
              </div>
              <div className="step-body">
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          className="damage-cta"
          initial={{ opacity: 0, y: 28 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 28 }}
          transition={{ duration: 0.8, delay: 1.0, ease: [0.16, 1, 0.3, 1] }}
        >
          <div className="damage-cta-text">
            <h3>Toch nog een vraag? Bel gewoon.</h3>
            <p>Wij leggen je alles uit!</p>
          </div>
          <div className="damage-cta-buttons">
            <a href="tel:+32497284662" className="cta-btn-primary">
              <FontAwesomeIcon icon={faPhoneAlt} />
              <span>Bel nu</span>
            </a>
            <a
              href="mailto:kris@carrosseriekris.be"
              className="cta-btn-secondary"
            >
              <FontAwesomeIcon icon={faEnvelope} />
              <span>Mail ons</span>
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
